// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2HwFx","fullView":"styles_fullView__ziBma"};